import { IFilter, IAdvFilter, ISorting } from '../types/UI/GenesisTable.type';
import dayjs from 'dayjs';

const TABLE_FILTER = 'table-filter';

const NUMBER_5 = 5;
const NUMBER_10 = 10;
const NUMBER_15 = 15;
export const NUMBER_20 = 20;
const NUMBER_25 = 25;
const NUMBER_50 = 50;
export const NUMBER_100 = 100;
const NUMBER_250 = 250;

export const PAGINATION_OPTIONS = [
  NUMBER_5,
  NUMBER_10,
  NUMBER_15,
  NUMBER_20,
  NUMBER_25,
  NUMBER_50,
  NUMBER_100,
  NUMBER_250,
];

const compareValues = (aValue: string | number, bValue: string | number, order: string | null) => {
  if (typeof aValue === 'string' && typeof bValue === 'number') {
    return order === 'Asc' ? -1 : 1;
  }
  if (typeof aValue === 'number' && typeof bValue === 'string') {
    return order === 'Asc' ? 1 : -1;
  }
  if (aValue > bValue) {
    return order === 'Asc' ? 1 : -1;
  }
  if (aValue < bValue) {
    return order === 'Desc' ? 1 : -1;
  }
  return 0;
};

export const sortingData = (
  itemsCollection: Array<any>,
  order: string | null,
  key: string,
  fieldType?: string,
) => {
  const getSortableValue = (value: unknown): string | number => {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    if (fieldType === 'number') {
      const numericValue = typeof value === 'number' ? value : Number(value);
      return Number.isNaN(numericValue) ? '' : numericValue;
    }

    if (fieldType === 'date') {
      if (typeof value === 'string' || typeof value === 'number' || value instanceof Date) {
        const dateValue = dayjs(value);
        return dateValue.isValid() ? dateValue.valueOf() : '';
      }

      return '';
    }

    if (typeof value === 'string') {
      return value.toLowerCase();
    }

    if (typeof value === 'number') {
      return value;
    }

    return '';
  };

  return [...itemsCollection].sort((a, b) => {
    const aValue = getSortableValue(a[key]);
    const bValue = getSortableValue(b[key]);
    return compareValues(aValue, bValue, order);
  });
};

export const handleAdvFilters = (
  field: string,
  filter1: string,
  value1: string | number,
  filter2: string,
  value2: string | number,
  fieldType: string,
  condition: string,
) => {
  let buildFilter: IAdvFilter = {
    propertyName: field,
    isNumeric: fieldType === 'number',
    constraint1: {
      operator: filter1,
      searchValue: value1,
    },
  };
  if (value2) {
    buildFilter = {
      ...buildFilter,
      logicalOperator: condition,
      constraint2: {
        operator: filter2,
        searchValue: value2,
      },
    };
  }
  return buildFilter;
};

export const handleGenerateAdvFilter = (filterData) => {
  const objKeys: string[] = Object.keys(filterData) || [];
  const filterArray: IAdvFilter[] = [];
  objKeys.forEach((key: string) => {
    const item: IFilter = filterData[key];
    const filter = handleAdvFilters(
      item.field,
      item.filterOne,
      item.filterOneValue,
      item.filterTwo,
      item.filterTwoValue,
      item.type,
      item.condition,
    );
    filterArray.push(filter);
  });
  return filterArray;
};

export const handlePersistFilter = (
  fieldFilter: any,
  tableName: string,
  currentPage: number,
  currentPageSize: number,
  sortedColumn: ISorting,
) => {
  if (tableName) {
    let storedFilter: any = sessionStorage.getItem(TABLE_FILTER);
    storedFilter = storedFilter !== null ? JSON.parse(storedFilter) : {};
    storedFilter[tableName] = {
      filter: fieldFilter,
      currentPage,
      currentPageSize,
      sorting: sortedColumn,
    };
    sessionStorage.setItem(TABLE_FILTER, JSON.stringify(storedFilter));
  }
};

export const handlePersistSorting = (
  filters: any,
  fieldSorting: ISorting,
  tableName: string,
  currentPage: number,
  currentPageSize: number,
) => {
  if (tableName) {
    let storedFilter: any = sessionStorage.getItem(TABLE_FILTER);
    storedFilter = storedFilter !== null ? JSON.parse(storedFilter) : {};
    storedFilter[tableName] = {
      filter: filters,
      currentPage,
      currentPageSize,
      sorting: fieldSorting,
    };
    sessionStorage.setItem(TABLE_FILTER, JSON.stringify(storedFilter));
  }
};
